import React from 'react';
import styled from 'styled-components';

import { Button } from '@lt/components';

import type { WidgetSettingsConstructorParams } from 'src/context/constructorContext/types';

interface IUtmParamsControl {
  controlName: string;
  newUtmParams: Array<Array<string>>;
  setNewUtmParams: React.Dispatch<React.SetStateAction<[string, string][]>>;
  config: Partial<WidgetSettingsConstructorParams>;
  onWidgetSettingsChange: (newConfig: Partial<WidgetSettingsConstructorParams>) => void;
}

interface IObjectInputControl extends IUtmParamsControl {
  utmParam: Array<string>;
  isKey: boolean;
  i: number;
}

export const UtmParamsControl = (props: IUtmParamsControl): JSX.Element => {
  const { controlName, newUtmParams, setNewUtmParams, config, onWidgetSettingsChange } = props;

  return (
    <div>
      {newUtmParams.map((utmParam, i) => (
        <ObjectControlsContainer key={i}>
          <ObjectInputControl
            controlName={controlName}
            isKey
            utmParam={utmParam}
            newUtmParams={newUtmParams}
            setNewUtmParams={setNewUtmParams}
            i={i}
            config={config}
            onWidgetSettingsChange={onWidgetSettingsChange}
          />
          <ObjectInputControl
            controlName={controlName}
            isKey={false}
            utmParam={utmParam}
            newUtmParams={newUtmParams}
            setNewUtmParams={setNewUtmParams}
            i={i}
            config={config}
            onWidgetSettingsChange={onWidgetSettingsChange}
          />
          <StyledDeleteButton
            size="tiny"
            primary
            type="button"
            onClick={() => {
              const newConfig = JSON.parse(JSON.stringify(config));
              delete newConfig[controlName].value[utmParam[0]];

              onWidgetSettingsChange(newConfig);
            }}
          >
            X
          </StyledDeleteButton>
        </ObjectControlsContainer>
      ))}
      <StyledButton
        onClick={() => {
          const newConfig = JSON.parse(JSON.stringify(config));
          newConfig[controlName].value[''] = '';

          onWidgetSettingsChange(newConfig);
        }}
        size="tiny"
        primary
      >
        Добавить
      </StyledButton>
    </div>
  );
};

const ObjectInputControl = (props: IObjectInputControl): JSX.Element => {
  const {
    controlName,
    isKey,
    utmParam,
    newUtmParams,
    setNewUtmParams,
    i,
    config,
    onWidgetSettingsChange,
  } = props;
  const index = isKey ? 0 : 1;

  return (
    <Input
      placeholder={isKey ? 'Ключ' : 'Значение'}
      value={utmParam[index]}
      onChange={(e) => {
        const newParams = JSON.parse(JSON.stringify(newUtmParams));
        newParams[i][index] = e.target.value;

        setNewUtmParams(newParams);
      }}
      onBlur={() => {
        const newConfig = JSON.parse(JSON.stringify(config));
        newConfig[controlName].value = Object.fromEntries(newUtmParams);

        onWidgetSettingsChange(newConfig);
      }}
    />
  );
};

const ObjectControlsContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 5px;
`;

const Input = styled.input`
  width: 100%;
  height: 38px;
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  padding: 2px 8px;

  &:focus {
    border-color: #007aff;
    border-width: 2px;
  }
`;

const StyledDeleteButton = styled(Button)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    flex-shrink: 0;
  }
`;

const StyledButton = styled(Button)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    margin-top: 5px;
  }
`;
